export const REQUEST_SESSION_HISTORY_DATE_FORMAT = 'DD-MM-YYYY';